import { render, staticRenderFns } from "./RequestHistorialTable.vue?vue&type=template&id=4913c860&scoped=true"
import script from "./RequestHistorialTable.vue?vue&type=script&lang=ts"
export * from "./RequestHistorialTable.vue?vue&type=script&lang=ts"
import style0 from "./RequestHistorialTable.vue?vue&type=style&index=0&id=4913c860&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4913c860",
  null
  
)

export default component.exports